import { CARDKNOX_LIB_VERSION, IXOPAY_GATEWAY_URL } from 'helpers/env';

export const PAYMENT = {
  CUSTOM: 'custom',
  FIX: 'fixed',
  PAST_DUE: 'pastDue',
};

export const CUSTOM_AMOUNT_HELPER_TEXT = {
  BOTH: 'Enter any amount, more or less than what is due.',
  LESS: 'Enter any amount, less than what is due.',
} as const;

// Payment method constants
export const PAYMENT_METHOD = {
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
} as const;

// Payment method type strings for API
export const PAYMENT_METHOD_TYPE = {
  APPLE_PAY: 'applepay',
  CARD: 'card',
  GOOGLE_PAY: 'googlepay',
} as const;

export enum FEE_STRUCTURE {
  ABSORB = 'absorb',
  HYBRID = 'hybrid',
  PASSTHROUGH = 'passthrough',
}

export enum PLAN_TYPE {
  CUSTOM = 'custom',
  PLUS = 'plus',
  STANDARD = 'standard',
}

export enum PAYMENT_GATEWAY_NAME {
  CARDKNOX = 'cardknox',
  IXOPAY = 'ixopay',
}

export enum DETERMINE_PAYMENT_METHOD_RETURN_TYPE {
  ERROR = 'ERROR',
  FINISHED = 'FINISHED',
  REDIRECT = 'REDIRECT',
}

export const PAYMENT_IFRAME_URL = `https://cdn.cardknox.com/ifields/${CARDKNOX_LIB_VERSION}/igp.htm`;

export const PAYMENT_IFRAME_SCRIPT_URL = `https://cdn.cardknox.com/ifields/${CARDKNOX_LIB_VERSION}/ifields.min.js`;

// Apple Pay SDK URL
export const APPLE_PAY_SDK_URL =
  'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

// must be loaded with data-main="payment-js"
export const IXOPAY_PAYMENT_JS_URL = `${IXOPAY_GATEWAY_URL}/js/integrated/payment.1.3.min.js`;

// ACH excluded — stays on the HPP redirect. Values match ExistingPaymentMethods in tools/constants/payPortal.ts.
export const IXOPAY_TOKEN_PAYMENT_TYPES = new Set<string>([
  'New Credit Card',
  'Google Pay',
  'Apple Pay',
]);

// IxoPay types and constants
export enum IxoPayTab {
  IN_PERSON = 'in-person',
  ONLINE = 'online',
}
export type TenderType = 'cash' | 'check';

export const PAYMENT_METHOD_TABS_VALUES = {
  IN_PERSON: IxoPayTab.IN_PERSON,
  ONLINE: IxoPayTab.ONLINE,
};

export const TENDER_TYPE_VALUES = {
  CASH: 'cash',
  CHECK: 'check',
} as const;

export const PAYMENT_METHOD_TABS: { label: string; value: IxoPayTab }[] = [
  { label: 'In-Person', value: PAYMENT_METHOD_TABS_VALUES.IN_PERSON },
  { label: 'Online', value: PAYMENT_METHOD_TABS_VALUES.ONLINE },
];
